import { useSelector } from 'react-redux';
import { SectionAlert, Txt } from '@vst/beam';
import { Construction, Router } from '@vst/beam-icons/icons';
import { useTranslation } from 'react-i18next';

import { selectChangePlan } from '@app/redux/changePlan';

const ModemAlert = () => {
  const { t } = useTranslation('ChangePlan', {
    keyPrefix: 'orderReview.details.modemReboot',
  });

  const {
    cart: { hasEquipmentForSelfInstall, requiresEquipmentChange },
  } = useSelector(selectChangePlan);

  if (hasEquipmentForSelfInstall)
    return (
      <SectionAlert
        variant="warning"
        mb="40px"
        contentSlot={
          <Txt color="regular" component="span" variant="smallRegular">
            {t('deviceInstallWarning')}
          </Txt>
        }
        icon={Construction}
      />
    );

  if (!requiresEquipmentChange)
    return (
      <SectionAlert
        data-cy="modem-reebot"
        variant="infoPrimary"
        mb="40px"
        contentSlot={
          <div>
            <Txt color="regular" component="span" variant="smallBold">
              {t('warning')}
            </Txt>
            <Txt color="regular" component="span" variant="smallRegular">
              {t('details')}
            </Txt>
          </div>
        }
        icon={Router}
      />
    );

  return null;
};

export default ModemAlert;
